import React from "react";
import { PROYECTOS } from "@/data/content";

export default function Proyectos() {
    return (
        <section
            id="proyectos"
            data-testid="proyectos-section"
            className="bg-orange text-navy relative py-24 md:py-32 px-5 md:px-10 border-y-4 border-navy"
        >
            <div
                aria-hidden
                className="absolute inset-0 stripes-diag opacity-[0.06] pointer-events-none"
            />
            <div className="relative max-w-[1400px] mx-auto">
                <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6 mb-14 fade-up">
                    <div>
                        <div className="font-display uppercase tracking-[0.3em] text-navy text-sm md:text-base mb-3 opacity-80">
                            / Nuestros Proyectos
                        </div>
                        <h2 className="font-heading text-navy text-4xl md:text-6xl lg:text-7xl leading-[1.02] max-w-3xl">
                            Campañas que
                            <span style={{ color: "#326d8e" }}> dejan huella.</span>
                        </h2>
                    </div>
                </div>

                <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
                    {PROYECTOS.map((p, idx) => (
                        <article
                            key={idx}
                            data-testid={`proyecto-card-${idx}`}
                            className={`bg-cream text-navy border-[5px] border-navy hard-shadow-cream transition-all duration-200 hover:-translate-y-1 fade-up ${
                                idx === 0 ? "md:col-span-2 lg:col-span-2" : ""
                            }`}
                        >
                            <div className="relative overflow-hidden border-b-[5px] border-navy">
                                <img
                                    src={p.img}
                                    alt={p.title}
                                    className={`w-full object-cover object-top ${
                                        idx === 0
                                            ? "h-72 md:h-96"
                                            : "h-56 md:h-64"
                                    }`}
                                />
                                <span className="absolute top-3 left-3 bg-gold text-navy border-4 border-navy px-3 py-1 font-display uppercase text-xs tracking-widest">
                                    0{idx + 1}
                                </span>
                            </div>
                            <div className="p-6 md:p-7">
                                <h3 className="font-display uppercase text-xl md:text-2xl tracking-wide leading-tight mb-3">
                                    {p.title}
                                </h3>
                                <p className="text-sm md:text-base leading-relaxed font-medium text-navy/85">
                                    {p.body}
                                </p>
                            </div>
                        </article>
                    ))}
                </div>
            </div>
        </section>
    );
}
